const API_BASE =
  import.meta.env.VITE_API_BASE_URL ??
  "https://club-codice-telegram-api.club-codice.workers.dev";

const ADMIN_KEY = "cc_admin_secret";
const BEARER_KEY = "cc_api_bearer";

export const ALL_SCOPES = [
  "posts:read",
  "posts:history",
  "media:read",
  "search:read",
  "sync:read",
] as const;

export type Scope = (typeof ALL_SCOPES)[number];

export function getApiBase() {
  return API_BASE.replace(/\/$/, "");
}

export function getAdminSecret() {
  return sessionStorage.getItem(ADMIN_KEY) ?? "";
}

export function setAdminSecret(value: string) {
  sessionStorage.setItem(ADMIN_KEY, value);
}

export function clearSession() {
  sessionStorage.removeItem(ADMIN_KEY);
  sessionStorage.removeItem(BEARER_KEY);
}

export function getBearer() {
  return sessionStorage.getItem(BEARER_KEY) ?? "";
}

export function setBearer(value: string) {
  sessionStorage.setItem(BEARER_KEY, value);
}

async function parseJson(res: Response) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { error: "invalid_json", message: text.slice(0, 200) };
  }
}

export async function adminFetch(path: string, init: RequestInit = {}) {
  const secret = getAdminSecret();
  const headers = new Headers(init.headers);
  headers.set("X-Admin-Secret", secret);
  headers.set("User-Agent", "ClubCodiceAdmin/1.0");
  if (init.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const res = await fetch(`${getApiBase()}${path}`, { ...init, headers });
  const json = await parseJson(res);
  if (!res.ok) {
    throw new Error(json.message || json.error || `HTTP ${res.status}`);
  }
  return json;
}

export async function apiFetch(path: string, init: RequestInit = {}) {
  const token = getBearer();
  if (!token) throw new Error("Configura un Bearer token en API Keys o Playground");
  const headers = new Headers(init.headers);
  headers.set("Authorization", `Bearer ${token}`);
  headers.set("User-Agent", "ClubCodiceAdmin/1.0");
  const res = await fetch(`${getApiBase()}${path}`, { ...init, headers });
  const json = await parseJson(res);
  if (!res.ok) {
    throw new Error(json.message || json.error || `HTTP ${res.status}`);
  }
  return json;
}

export function mediaUrl(id: string) {
  return `${getApiBase()}/api/v1/media/${id}?download=1`;
}
